export const IRIS_SOURCE = 'IRIS';
const MASKED_SECRET = '********';

export interface IrisProviderFormValues {
  name: string;
  userId: string;
  username: string;
  password?: string;
  apiUrl: string;
  rsaPrivateKey?: string;
  proxyAddress?: string[];
  isActive?: boolean;
  status?: string;
  otpConfirm: string;
}

export interface IrisProviderPayload extends IrisProviderFormValues {
  source: string;
  isActive: boolean;
  status: string;
  proxyAddress: string[];
}

const cleanStringList = (items: string[] = []) => (
  Array.from(new Set(
    items
      .filter((item): item is string => typeof item === 'string')
      .map(item => item.trim())
      .filter(Boolean)
  ))
);

const normalizeStatus = (status: string | undefined, isActive: boolean) => (
  status || (isActive ? 'Active' : 'Inactive')
);

const isChangedSecret = (value?: string) => {
  if (!value) {
    return false;
  }

  return value.trim() !== '' && value !== MASKED_SECRET;
};

export const buildCreateIrisProviderPayload = (values: IrisProviderFormValues): IrisProviderPayload => {
  const isActive = values.isActive ?? true;

  return {
    ...values,
    proxyAddress: cleanStringList(values.proxyAddress),
    source: IRIS_SOURCE,
    isActive,
    status: normalizeStatus(values.status, isActive),
  };
};

export const buildUpdateIrisProviderPayload = (providerName: string, values: IrisProviderFormValues): IrisProviderPayload => {
  const isActive = values.isActive ?? true;

  return {
    name: providerName,
    userId: values.userId,
    username: values.username,
    ...(isChangedSecret(values.password) ? { password: values.password } : {}),
    apiUrl: values.apiUrl,
    ...(isChangedSecret(values.rsaPrivateKey) ? { rsaPrivateKey: values.rsaPrivateKey } : {}),
    proxyAddress: cleanStringList(values.proxyAddress),
    source: IRIS_SOURCE,
    isActive,
    status: normalizeStatus(values.status, isActive),
    otpConfirm: values.otpConfirm,
  };
};
